import { ISearchCountModel } from '@apps-common/types/general'

interface IProps {
  loading: boolean
  count?: ISearchCountModel
  extraText?: string
  children?: React.ReactNode
}

export const PageResultsCount: React.FC<IProps> = ({ loading, count, extraText, children }) => (
  <>
    {!loading && count && (
      <div className='jost-light text-[0.85em] text-text flex items-center justify-start'>
        <span className='jost-medium'>{count?.resultCount}&nbsp;</span> {extraText ? `${extraText} ` : ''}results {children}
      </div>
    )}
    {(loading || !count) && <div className='h-[22px] w-[100px] bg-skeleton rounded-lg' />}
  </>
)
